import { IAuthState, AuthReducer } from '../auth'
import { combineReducers } from 'redux'
import { ThemeReducer, IThemeState } from '../theme'
import {
  HubChallengeBasicFormReducer,
  HubChallengeBasicFormValidationReducer,
  IHubChallengeBasicFormState,
  IHubChallengeBasicFormValidationState,
  resetChallengeSection
} from '../domain/feature/hub/company/challenge/FormWrapper/store'
import {
  HubChallengeBasicFormFilesReducer,
  IHubChallengeBasicFormFilesState,
  resetChallengeFiles
} from '../domain/feature/hub/company/challenge/FormWrapper/files/store'
import {
  HubStartupChallengeApplicationForm,
  IHubStartupChallengeApplicationForm,
  IHubStartupChallengeApplicationFilesState,
  HubStartupChallengeApplicationFiles
} from '../domain/feature/hub/startup/challenge/applicationForm/store'
import { ISidebarState, SidebarReducer } from '../components/menu/side/store'
import { MenuEvaluatorsReducer } from '../components/menu/state/content/store'
import { EvaluationMenuReducer, IEvaluationMenuState } from '../components/menu/state/control/store'
import { solutionReducer } from '../domain/feature/hub/evaluator/challenge/store'
import {
  HubProfileImageReducer,
  IProfileImage
} from '../domain/feature/hub/user-config/profileImage'
import {
  HubUserConfigFormReducer,
  IUserConfigForm
} from '../domain/feature/hub/user-config/PersonalConfigForm/store/configForm'
import {
  HubPasswordFormReducer,
  IPasswordForm
} from '../domain/feature/hub/user-config/ChangePasswordForm/store'
import { HotsiteChallengesReducer, HotsiteChallengeProps, HotsiteEventProps, HotsiteEventsReducer } from '../domain/feature/hotsite/store'
import { IHotsiteRegisterForm, HotsiteRegisterFormReducer, IHotsiteEvaluatorRegisterForm, HotsiteEvaluatorRegisterFormReducer } from '../domain/feature/hotsite/Forms/Register/store'
import { evaluatorSolutionReducer, IEvaluatorSolutionState } from '../domain/feature/hub/company/challenge/evaluators/assign/store'
import { IHubEventBasicFormState } from '../domain/feature/hub/company/events/FormWrapper/store/contracts'
import { IHubEventBasicFormFilesState } from '../domain/feature/hub/company/events/FormWrapper/file/store/contracts'
import { HubEventBasicFormReducer } from '../domain/feature/hub/company/events/FormWrapper/store/reducer'
import { HubEventBasicFormFilesReducer } from '../domain/feature/hub/company/events/FormWrapper/file/store/reducer'
import { HubEventBasicFormValidationReducer } from '../domain/feature/hub/company/events/FormWrapper/store/validations'

export type TReducers = {
  isDarkModeOn: IThemeState
  hubChallengeBasicFormState: IHubChallengeBasicFormState
  hubChallengeBasicFormValidationState: IHubChallengeBasicFormValidationState
  hubChallengeBasicFormFilesState: IHubChallengeBasicFormFilesState
  hubEventBasicFormState: IHubEventBasicFormState
  hubEventBasicFormFilesState: IHubEventBasicFormFilesState
  startupHubChallengeApplicationFormState: IHubStartupChallengeApplicationForm
  startupHubChallengeApplicationFormFilesState: IHubStartupChallengeApplicationFilesState
  auth: IAuthState
  sidebarState: ISidebarState
  menuEvaluatorsState: any
  isEvaluationMenu: IEvaluationMenuState
  solutionReducer: any
  evaluatorSolutionState: IEvaluatorSolutionState
  hubIProfileImage: IProfileImage
  hubUserConfigForm: IUserConfigForm
  hubIPasswordState: IPasswordForm
  hotsiteChallengesData: HotsiteChallengeProps
  hotsiteEventsData: HotsiteEventProps
  hotsiteIHotsiteRegisterFormState: IHotsiteRegisterForm
  hotsiteIHotsiteEvaluatorRegisterFormState: IHotsiteEvaluatorRegisterForm
}

const reducers = combineReducers({
  isDarkModeOn: ThemeReducer,
  isEvaluationMenu: EvaluationMenuReducer,
  hubChallengeBasicFormState: HubChallengeBasicFormReducer,
  hubChallengeBasicFormValidationState: HubChallengeBasicFormValidationReducer,
  hubEventBasicFormState: HubEventBasicFormReducer,
  hubEventBasicFormFilesState: HubEventBasicFormFilesReducer,
  hubEventBasicFormValidationState: HubEventBasicFormValidationReducer,
  startupHubChallengeApplicationFormState: HubStartupChallengeApplicationForm,
  startupHubChallengeApplicationFormFilesState: HubStartupChallengeApplicationFiles,
  auth: AuthReducer,
  hubChallengeBasicFormFilesState: HubChallengeBasicFormFilesReducer,
  sidebarState: SidebarReducer,
  menuEvaluatorsState: MenuEvaluatorsReducer,
  solutionReducer: solutionReducer,
  evaluatorSolutionState: evaluatorSolutionReducer,
  hubIProfileImage: HubProfileImageReducer,
  hubUserConfigForm: HubUserConfigFormReducer,
  hubIPasswordState: HubPasswordFormReducer,
  hotsiteChallengesData: HotsiteChallengesReducer,
  hotsiteEventsData: HotsiteEventsReducer,
  hotsiteIHotsiteRegisterFormState: HotsiteRegisterFormReducer,
  hotsiteIHotsiteEvaluatorRegisterFormState: HotsiteEvaluatorRegisterFormReducer
})

export default reducers
